"use strict";function i(i){return i&&"object"==typeof i&&"default"in i?i:{default:i}}const e=i(require("styled-components")).default.section`
  background: ${({theme:i})=>i.colors.grey[50]};
  min-height: 100vh;

  .inner {
    display: grid;
    align-items: flex-start;
    max-width: ${({theme:i})=>i.widths.small};
    margin: auto;

    @media (min-width: ${({theme:i})=>i.breakpoints.large}) {
      ${({hasVisualizer:i,isHealthy:e})=>i&&e?"\n              grid-template-areas: 'main options';\n              grid-template-columns: 1fr 467px;\n            ":"\n              grid-template-areas:\n                'main'\n                'options';\n            "}
      max-width: ${({theme:i})=>i.widths.xlarge};
      max-height: calc(${({theme:i})=>i.widths.xlarge} * .5625)
    }

    > .main {
      display: grid;
      grid-template-rows: min-content;
      grid-template-areas:
        'visualizer'
        'nav';
      background: ${({theme:i})=>i.colors.grey[50]};
      z-index: 10;
      position: sticky;
      top: 0;

      @media (min-width: ${({theme:i})=>i.breakpoints.large}) {
        grid-template-areas:
          'nav'
          'visualizer';
        grid-template-rows: min-content 1fr;
        position: sticky;
        top: 0;
        height: ${({hasVisualizer:i,isHealthy:e})=>i&&e?"100vh":"auto"};
        max-height: calc(${({theme:i})=>i.widths.xlarge} * .5625)
      }

      > .navigation {
        grid-area: nav;
      }

      > .visualizer {
        grid-area: visualizer;
        height: auto;

        .DXLoading {
          position: absolute;
          background-color: ${({theme:i})=>i.colors.common.light};
        }
      }

      > .view-2d .visible img {
        object-fit: contain;
      }
    }

    > .options {
      margin: 0 auto;
      width: 100%;
      box-sizing: border-box;
      overflow: ${({hasVisualizer:i})=>i?"hidden":"visible"};

      @media (min-width: ${({theme:i})=>i.breakpoints.large}) {
        max-width: ${({hasVisualizer:i,isHealthy:e})=>i&&e?"none":"391px"};
      }
    }
  }
`;module.exports=e;
//# sourceMappingURL=styles.js.map
